function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Fonts",
  transform: "translate(-836.000000, -3620.000000)",
  stroke: "#80A1FE"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons/Regular/message",
  transform: "translate(837.000000, 3621.854741)"
}, /*#__PURE__*/React.createElement("g", {
  id: "message-square"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18,12 C18,13.1045695 17.1045695,14 16,14 L4,14 L0,18 L0,2 C0,0.8954305 0.8954305,0 2,0 L16,0 C17.1045695,0 18,0.8954305 18,2 L18,12 Z",
  id: "Shape",
  strokeWidth: 2
})))));

var SvgChatBubbleOutlined = function SvgChatBubbleOutlined(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "21px",
    viewBox: "0 0 20 21",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChatBubbleOutlined, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chat-bubble-outlined.18ad8523.svg";
export { ForwardRef as ReactComponent };